import React, { Component } from "react";
import { VendorService } from "../services/VendorService";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar';
import { Toolbar } from 'primereact/toolbar';
import moment from 'moment';
import "../custom.css";

export class PaidVendors extends Component {
    static displayName = PaidVendors.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            filters: {
                'VendorName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
            },
            vendorFilters: {},
            expandedRows: null,
            vendors: []
        };

        this.vendorService = new VendorService();
        this.exportCSV = this.exportCSV.bind(this);

        //row collapse bindings
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.onRowExpand = this.onRowExpand.bind(this);
    }

    componentDidMount() {
        this.vendorService.getPaidVendorsData().then((data) => {
            const paidVendors = data;
            this.setState({ vendors: data, loading: false });
        });
    }

    dtHeader() {
        const leftContents = (
            <React.Fragment>
                <span><h3>Paid Vendors</h3></span>
            </React.Fragment>
        );

        const rightContents = (
            <React.Fragment>
                <Button className=".btn-primary mr-2" type="button" icon="pi pi-file-excel" label="Paid Vendors" onClick={this.exportCSV} data-pr-tooltip="XLS" />
            </React.Fragment>
        );

        return (
            <Toolbar left={leftContents} right={rightContents} />
        );
    }

    async exportCSV() {
        await this.vendorService.downloadPaidVendorsCSV();
    }

    getVendorFilters = () => {
        return ({
            'Amount': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'BillDate': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'CheckNumber': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'DueDate': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'InvoiceNumber': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'PaidDate': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'Status': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    async onRowExpand(event) {
        this.setState({ loading: true });
        const checkData = await this.vendorService.getVendorCheckData(event.data.VendorNumber);
        let vendors = this.state.vendors;

        let vendor = vendors.find(x => x.VendorNumber === event.data.VendorNumber);
        vendor.checks = checkData;

        let vendorFilters = this.state.vendorFilters;
        vendorFilters[event.data.VendorNumber] = this.getVendorFilters();

        this.setState({ vendors, vendorFilters, loading: false });
    }

    formatCurrency(value) {
        if (value === undefined || value === null) {
            return null;
        }
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    formatDate(value) {
        if (value === undefined || value === null) {
            return null;
        }
        return moment(value).format('MM-DD-YYYY');
    }

    rowExpansionTemplate(data) {
        return (
            <div className="vendors-subtable">
                <h5 style={{ color: 'white' }}>Checks for {data.VendorName} ({data.VendorNumber})</h5>
                <DataTable value={data.checks}
                    responsiveLayout="scroll"
                    size="small"
                    filters={this.state.vendorFilters[data.VendorNumber]}
                    filterDisplay="menu"
                    paginator={true}
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    loading={this.state.loading}
                    loadingIcon="pi pi-spinner"
                >
                    <Column field="Status" header="Status" sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="CheckNumber" header="Check Number" body={(rowData) => rowData.CheckNumber} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="InvoiceNumber" header="Invoice Number" body={(rowData) => rowData.InvoiceNumber} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="BillDate" header="Bill Date" body={(rowData) => this.formatDate(rowData.BillDate)} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="DueDate" header="Due Date" body={(rowData) => this.formatDate(rowData.DueDate)} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="PaidDate" header="Paid Date" body={(rowData) => this.formatDate(rowData.PaidDate)} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                    <Column field="Amount" header="Amount" body={(rowData) => this.formatCurrency(rowData.Amount)} sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}></Column>
                </DataTable>
            </div>
        );
    }

    render() {
        const header = this.dtHeader();

        return (
            <div>
                {this.state.loading ? <ProgressBar mode="indeterminate" style={{ height: '4px' }} /> : ''}
                <div className="row" >
                    <div className="p-col-12" >
                        <Toast ref={(el) => this.toast = el} />
                        <div style={{ height: 'calc(100vh - 170px)' }}>
                            <DataTable
                                ref={(el) => { this.dt = el; }}
                                value={this.state.vendors}
                                header={header}
                                size="small"
                                filters={this.state.filters}
                                filterDisplay="menu"
                                paginator={true}
                                rows={100}
                                emptyMessage="No vendors found."
                                expandedRows={this.state.expandedRows}
                                onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                onRowExpand={this.onRowExpand}
                                onRowCollapse={this.onRowCollapse}
                                rowExpansionTemplate={this.rowExpansionTemplate}
                                sortField="VendorName"
                                sortOrder={1} //-1 = desc, 1 = asc
                                removableSort
                                scrollHeight="flex"
                                scrollable
                                loading={this.state.loading}
                                loadingIcon="pi pi-spinner"
                            >
                                <Column className="" expander style={{ width: "4em", maxWidth: "4em" }} />
                                <Column field="VendorName" header="Name" sortable filter filterPlaceholder="Search" style={{ minWidth: '12rem' }} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
